<template>
  <div class="pa-6">
    <div class="d-flex justify-end mb-4">
      <StudentReportExcelExport />
    </div>
    <StudentReportTable />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import StudentReportTable from './StudentReportTable.vue'
import StudentReportExcelExport from './StudentReportExcelExport.vue'

export default {
  components: { StudentReportTable, StudentReportExcelExport },
  methods: {
    ...mapActions({
      search: 'studentSurvey/search',
    }),
  },
  async mounted() {
    await this.search({ survey: this.$route.params.id, _sort: 'createdAt:DESC' })
  },
}
</script>
